import { createContext, useContext, useState, useEffect } from "react";
import { translations } from "../lib/i18n";

const AppContext = createContext(null);

export function AppProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("hrh_lang") || "en");

  useEffect(() => {
    localStorage.setItem("hrh_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = translations[lang];
  return <AppContext.Provider value={{ lang, setLang, t }}>{children}</AppContext.Provider>;
}

export function useApp() {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error("useApp must be used within AppProvider");
  return ctx;
}
